import type { ClientSession } from './api';
import { parseEventDetailPath } from '../shared/event-url';
export async function participationRequest<T>(
  path: string,
  session: ClientSession | null,
  method = 'GET',
  body?: unknown,
  extraHeaders?: Record<string, string>,
): Promise<T> {
  const url = new URL(path, location.origin);
  const eventMatch = url.pathname.match(/^\/api\/participation\/events\/([^/]+)/);
  const proof = eventMatch
    ? sessionStorage.getItem(
        participationProofKey(
          decodeURIComponent(eventMatch[1]!),
          url.searchParams.get('occurrence'),
        ),
      )
    : null;
  const response = await fetch(path, {
    method,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      ...extraHeaders,
      ...(proof ? { 'X-Participation-Proof': proof } : {}),
      ...(session?.csrfToken ? { 'X-CSRF-Token': session.csrfToken } : {}),
    },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  if (response.status === 204) return undefined as T;
  const data = (await response.json()) as T & { error?: string };
  if (!response.ok) throw new Error(data.error || 'This could not be saved. Please try again.');
  return data;
}
export function participationPath(eventId: string, occurrence?: string | null, suffix = '') {
  return `/api/participation/events/${encodeURIComponent(eventId)}${suffix}${occurrence ? `?occurrence=${encodeURIComponent(occurrence)}` : ''}`;
}

export function participationProofKey(eventId: string, occurrence?: string | null) {
  return `participation-proof:${eventId}:${occurrence || ''}`;
}
export async function participationSignIn(
  kind: 'event' | 'form',
  id: string,
  session: ClientSession | null,
) {
  await participationRequest('/api/participation/sign-in-context', session, 'POST', {
    kind,
    id,
    occurrence: kind === 'event' ? parseEventDetailPath(location.pathname).occurrence || '' : '',
  });
  location.assign(`/login?callbackURL=${encodeURIComponent(location.pathname + location.search)}`);
}
